<ngx-loading-bar #loading color="#3AA36B" includeSpinner="false" height="3px"></ngx-loading-bar>

<div id="service-order-new">
  <app-new [title]="title" [subtitle]="subtitle" [urlBack]="urlBack">
    <div class="container" [formGroup]="newServiceOrder">
      <div class="row">
        <div class="col">
          <label>
            <span>BANDEIRA</span>

            <select formControlName="cdBandeira" (change)="getStores($event.target.value);">
              <option value="">Selecione a bandeira</option>
              <option *ngFor="let flag of flagsArr;" [value]="flag.cdLogomarca">{{ flag.dsLogomarca }}</option>
            </select>
          </label>
        </div>

        <div class="col">
          <label>
            <span>LOJA</span>

            <select formControlName="cdFilial">
              <option value="" *ngIf="storesArr.length == 0">Selecione uma bandeira</option>
              <option value="" *ngIf="storesArr.length > 0">Selecione a loja</option>
              <option *ngFor="let store of storesArr;" [value]="store.cdFilial">{{ store.nmFantasia }}</option>
            </select>
          </label>
        </div>

        <div class="col">
          <label>
            <span>LOJA NOVA</span>

            <select formControlName="flNovaLoja" (change)="newStore($event.target.value);">
              <option value="1">Sim</option>
              <option value="0">Não</option>
            </select>
          </label>
        </div>
      </div>

      <div *ngIf="newServiceOrder.value.flNovaLoja == '1';">
      <div class="row">
        <div class="col">
          <label>
            <span>PRESTADOR DE SERVIÇO</span>

            <select formControlName="cdFornecedor" (change)="getEquipments($event.target.value);">
              <option value="">Selecione o prestador de serviço</option>
              <option *ngFor="let provider of providersArr;" [value]="provider.cdFornecedor">{{ provider.nmRazaoSocial }}</option>
            </select>
          </label>
        </div>

        <div class="col">
          <label>
            <span>TIPO DE SERVIÇO</span>

            <select disabled>
              <option>Instalação</option>
            </select>
          </label>
        </div>
      </div>

        <div class="row" *ngIf="newServiceOrder.value.cdFornecedor">
          <div class="col">
            <h1>EQUIPAMENTOS</h1>
            <div id="list">
              <table width="100%">
                <thead>
                  <tr>
                    <th>
                      <div>Código</div>
                    </th>

                    <th>
                      <div>Descrição</div>
                    </th>

                    <th>
                      <div>Código SAP</div>
                    </th>

                    <th>
                      <div>Quantidade</div>
                    </th>

                    <th>
                      <div>Valor</div>
                    </th>

                    <th>
                      <div>Selecionado</div>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <ng-container *ngFor="let equipment of arrayTemp; let i = index">
                    <tr [ngClass]="{'row-disabled': !equipment.checked}">
                        <td>
                          {{equipment.equipamento.cdProduto}}
                        </td>

                        <td>
                          {{equipment.equipamento.dsProduto}}
                        </td>

                        <td>
                          {{equipment.equipamento.cdsProdutoSap}}
                        </td>

                        <td>
                          <input type="number" formControlName="quantidade" [ngClass]="{'input-disabled': !equipment.checked}" (change)="outputEquipments(i, equipment);">
                        </td>

                        <td>
                          {{equipment.equipamento.vlProduto | currencyFormat: 'pt-BR'}}
                        </td>

                        <td>
                            <div class="text-align-center" id="checkbox">
                                <fieldset (click)="toggleCheckbox(i, equipment.equipamento.cdProduto);"  [class.active]="equipment.checked">
                                  <span class="icn-check"></span>
                                </fieldset>
                              </div>
                        </td>   
                      </tr>
                    </ng-container>
                </tbody>
              </table>
            </div>

            <div id="list" class="no-result" *ngIf="equipmentsArr.length == 0">
              <h1>Sua pesquisa não retornou resultados.</h1>
            </div>

          </div>
        </div>
      </div>

      <div class="row" *ngIf="newServiceOrder.value.flNovaLoja == '0';">
        <div class="col">
          <label>
            <span>EQUIPAMENTO</span>

            <select (change)="getServiceProviders($event.target.value);">
              <option value="">Selecione o equipamento</option>
              <option *ngFor="let equipment of equipmentsArr;" [value]="equipment.cdProduto">{{ equipment.dsProduto }}</option>
            </select>
          </label>
        </div>

        <div class="col">
          <label>
            <span>PRESTADOR DE SERVIÇO</span>

            <select formControlName="cdFornecedor">
              <option value="" *ngIf="providersArr.length == 0">Selecione um equipamento</option>
              <option value="" *ngIf="providersArr.length > 0">Selecione o prestador de serviço</option>
              <option *ngFor="let provider of providersArr;" [value]="provider.cdFornecedor">{{ provider.nmRazaoSocial }}</option>
            </select>
          </label>
        </div>

        <div class="col">
          <label>
            <span>TIPO DE SERVIÇO</span>

            <select formControlName="cdTpServico">
              <option value="">Selecione o tipo de serviço</option>
              <option *ngFor="let service of servicesArr;" [value]="service.cdTpServico">{{ service.dsTpServico }}</option>
            </select>
          </label>
        </div>
      </div>

      <div class="row relato">
        <div class="col">
          <label>
            <span>RELATO DO CHAMADO</span>

            <textarea formControlName="dsObservacao"></textarea>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <button (click)="addNewServiceOrder();">CADASTRAR ORDEM DE SERVIÇO</button>
        </div>
      </div>
    </div>
  </app-new>
</div>
